import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { Row, Col, FormGroup } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { MultiSelect } from 'react-multi-select-component';
import { cloneDeep, isEmpty, isArray } from 'lodash';
import Select from 'react-select';
import { createOptions, monthsPlaceholder, getYears, checkArray, converDropdownData, customStyles } from '../../Components/helper';
import * as bomLibAction from '../Library/BomLibrary/store/BomLibrary.action';
import * as systemMasterAction from '../SystemMasters/Store/SystemMasters.action';
import * as action from '../DevlopmentOrder/store/DevelopmentOrder.action';
import { usePlanningBottomupState } from './Context';
import { toasterMsg } from '../../Components/Toaster/Toaster';
import * as sampleTodoListAction from '../Dashboard/TodoList/Samples/store/TodoList.action';
import * as PlanningBottomAction from './store/PlanningBottom.action';
import { CurrentYearOption } from '../../Components/Utility/CurrentYearDropdown';

function FilterBottomTop({ filterData, planningState, setPlanningState }) {
  const reducer = useSelector((reducerState) => reducerState);
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const { UserDetails, SystemMastersDetails, BomLibraryDetails, Measuremets } = reducer;
  const { userInfo } = UserDetails;
  const { adminUsers, companyUsers } = Measuremets;
  const { ReferenceSupplier } = BomLibraryDetails;
  const {
    brandList,
    category1List,
    category2List,
    pcTypeList,
    productStatusList,
    seasonList,
    category3List,
    category4List,
    customAttributeList,
    multiSubBrandList,
  } = SystemMastersDetails;
  const localStorageFilter = JSON.parse(localStorage.getItem('bottomUpFilter'));
  const [state, setState] = useState({
    brandOptions: [],
    subBrandOptions: [],
    category1Options: [],
    category2Options: [],
    category3Options: [],
    category4Options: [],
    category1Raw: [],
    category2Raw: [],
    category3Raw: [],
    category4Raw: [],
    productTypeOptions: [],
    productStatusOptions: [],
    seasonOptions: [],
    supplierOptions: [],
    createdByOption: [],
    monthOptions: createOptions(monthsPlaceholder, 'name', '_id'),
    yearOptions: createOptions(getYears(), 'name', '_id'),
    activeBrand: [],
    activeSubBrand: [],
    activeProductType: [],
    activeCat1: [],
    activeCat2: [],
    activeCat3: [],
    activeCat4: [],
    activeSupplier: [],
    activeSeason: [],
    activeMonth: [],
    activeYear: [],
    activeStatus: [],
    activeCreatedBy: [],
    dynamicFields: [],
    dynamicTypes: [],
    categoryOptions: [],
    selectedYear: '',
    seasonsOptions: [],
    attributesOptions: [],
    selectedAttributesOptions: [],
    selectedSeason: '',
    filterApplied: false,
    isLoading: false,
    level: null,
    isApply: false,
    isAll: localStorageFilter?.isAllSelected,
  });
  const {
    brandOptions,
    subBrandOptions,
    category1Options,
    category2Options,
    category3Options,
    category4Options,
    productTypeOptions,
    productStatusOptions,
    supplierOptions,
    monthOptions,
    yearOptions,
    createdByOption,
    activeBrand,
    activeSubBrand,
    activeProductType,
    activeCat1,
    activeCat2,
    activeCat3,
    activeCat4,
    activeSupplier,
    activeSeason,
    activeMonth,
    activeStatus,
    activeCreatedBy,
    dynamicFields,
    dynamicTypes,
    selectedYear,
    seasonsOptions,
    selectedSeason,
    filterApplied,
    attributesOptions,
    isLoading,
    level,
    isApply,
    isAll,
  } = state;
  const [selectedYear1, setSelectedYear1] = useState();
  const [selectedSeason1, setSelectedSeason1] = useState();
  const reducers = useSelector((redState) => redState);
  const {
    UserDetails: {
      userInfo: { userId },
    },
  } = reducers;
  const { planningBottomup, setPlanningBottomup, lengthEnabled } = usePlanningBottomupState();
  const { levelOptions, displayColumns, selectedDisplayColumn } = planningBottomup;
  const { PlanningBottomReducer } = reducer;
  const { ActiveChannels } = PlanningBottomReducer;
  const [subBrandAccess, setSubBrandAccess] = useState(false);
  const [catBasedOnPTData, setCatBasedOnPTData] = useState(false);

  const filterOptions = lengthEnabled ? levelOptions : levelOptions.filter((ele) => ele?.name !== 'Length');

  useEffect(() => {
    const fetchSubBrandAccess = async () => {
      const subBrandAccessRes = await dispatch(systemMasterAction.getSubBrandAccess());
      setSubBrandAccess(subBrandAccessRes?.data || false);
    };
    fetchSubBrandAccess();
  }, [dispatch]);

  // Fetch company-level flag to enable PT-based cascading
  useEffect(() => {
    const fetchFlag = async () => {
      try {
        const res = await dispatch(systemMasterAction.getCatBasedOnPT());
        setCatBasedOnPTData(!!res);
      } catch (e) {
        setCatBasedOnPTData(false);
      }
    };
    fetchFlag();
  }, [dispatch]);

  useEffect(() => {
    const callFn = async () => {
      await dispatch(
        systemMasterAction.getMultiSubBrandDetails({
          brandId: activeBrand,
          loggedInUserId: userInfo?.userId,
          isActive: 1,
        }),
      );
    };
    if (checkArray(activeBrand)) {
      callFn();
    }
  }, [activeBrand]);

  useEffect(() => {
    const Init = async () => {
      await dispatch(systemMasterAction.getCustomAttributeFreeText());
      await dispatch(
        systemMasterAction.getPCTypesDetails({
          loggedInUserId: userInfo?.userId,
          isActive: true,
          tier: 'Tier1',
        }),
      );
      await dispatch(
        systemMasterAction.getSeasonsDetails({
          loggedInUserId: userInfo?.userId,
        }),
      );
      await dispatch(
        systemMasterAction.getBrandDetails({
          loggedInUserId: userInfo?.userId,
          isActive: 1,
        }),
      );
      await dispatch(
        systemMasterAction.getCategory1Details({
          categoryType: 1,
          loggedInUserId: userInfo?.userId,
          isActive: true,
        }),
      );
      await dispatch(
        systemMasterAction.getCategory2Details({
          categoryType: 2,
          loggedInUserId: userInfo?.userId,
          isActive: true,
        }),
      );
      await dispatch(bomLibAction.fetchBomReferenceSupplier());
      await dispatch(action.getAdminUser());
      await dispatch(action.getCompanyUser({ CompanyUsers: true }));
      await dispatch(
        systemMasterAction.getProductStatusDetails({
          loggedInUserId: userInfo?.userId,
          isActive: 1,
        }),
      );
    };

    Init();
  }, []);

  const filteredSubBrands = useMemo(() => {
    if (!isArray(multiSubBrandList) || !multiSubBrandList?.length) {
      return [];
    }
    if (!activeBrand?.length) {
      return [];
    }

    // Filter sub-brands to only include those from selected brands
    return multiSubBrandList
      .filter((option) => activeBrand.includes(option.brandId))
      .map((option) => ({
        ...option,
        label: option?.name,
        value: option?._id,
      }));
  }, [multiSubBrandList, activeBrand]);

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      brandOptions: createOptions(brandList, 'name', '_id'),
      subBrandOptions: filteredSubBrands,
      category1Options: createOptions(category1List, 'name', '_id'),
      category2Options: createOptions(category2List, 'name', '_id'),
      category1Raw: category1List || [],
      category2Raw: category2List || [],
      productTypeOptions: createOptions(pcTypeList, 'name', '_id'),
      productStatusOptions: createOptions(productStatusList, 'name', '_id'),
      seasonOptions: createOptions(seasonList, 'name', '_id'),
      supplierOptions: createOptions(ReferenceSupplier, 'name', '_id'),
    }));
  }, [brandList, category1List, category2List, pcTypeList, productStatusList, seasonList, ReferenceSupplier, filteredSubBrands]);

  useEffect(() => {
    const callFun = async () => {
      const customAttr = await converDropdownData(customAttributeList);
      setState((prevState) => ({
        ...prevState,
        dynamicFields: customAttr,
      }));
    };
    if (checkArray(customAttributeList)) {
      callFun();
    }
  }, [customAttributeList?.length]);

  useEffect(() => {
    if (checkArray(category3List)) {
      setState((prevState) => ({
        ...prevState,
        category3Options: createOptions(category3List, 'name', '_id'),
        category3Raw: category3List || [],
      }));
    }
  }, [category3List]);

  useEffect(() => {
    if (checkArray(category4List)) {
      setState((prevState) => ({
        ...prevState,
        category4Options: createOptions(category4List, 'name', '_id'),
        category4Raw: category4List || [],
      }));
    }
  }, [category4List]);

  useEffect(() => {
    const allUser = [adminUsers, ...companyUsers];
    setState((prevState) => ({
      ...prevState,
      createdByOption: allUser.map((ele) => {
        return {
          label: `${ele?.firstName} ${ele?.lastName}`,
          value: ele?._id,
        };
      }),
    }));
  }, [adminUsers, companyUsers]);

  useEffect(() => {
    const lev = level?.level || 1;
    const existedLevelArr = [];
    const showArr = [];
    displayColumns.forEach((dis) => {
      if (dis?.existlevel <= lev) {
        existedLevelArr.push(dis);
      }
      if (dis?.existlevel <= lev && dis.hasOwnProperty('hideShow') === false) {
        showArr.push(dis);
      }
    });

    setState((prev) => ({
      ...prev,
      attributesOptions: showArr,
    }));
    if (attributesOptions.length > displayColumns?.length) {
      setPlanningBottomup((prev) => ({
        ...prev,
        selectedDisplayColumn: attributesOptions.map((dis) => dis?.value),
      }));
    } else {
      setPlanningBottomup((prev) => ({
        ...prev,
        selectedDisplayColumn: existedLevelArr.map((dis) => dis?.value),
      }));
    }
  }, [level]);

  useEffect(() => {
    const newChannel = ActiveChannels.map((val) => {
      return { ...val, value: val?.refKey, label: val?.channelName };
    });
    setState((prev) => ({
      ...prev,
      attributesOptions: [...prev.attributesOptions, ...newChannel],
    }));

    if (isAll === true || isAll === undefined) {
      setPlanningBottomup((prev) => ({
        ...prev,
        selectedDisplayColumn: [...prev.selectedDisplayColumn, ...newChannel.map((dis) => dis?.value)],
      }));
    } else {
      setPlanningBottomup((prev) => ({
        ...prev,
        selectedDisplayColumn: localStorageFilter?.selectedDisplayColumn,
      }));
    }
  }, [ActiveChannels, level]);

  const setSeasonsData = useCallback(async () => {
    const seasonsRes = await dispatch(
      bomLibAction.fetchSeason({
        isActive: 1,
        loggedInUserId: userId,
      }),
    );
    const seasonsOpt = createOptions(seasonsRes?.payload, 'name', '_id');
    setState((prevState) => ({
      ...prevState,
      seasonsOptions: seasonsOpt,
    }));
  }, [dispatch, userId]);

  useEffect(() => {
    const fetchData = async () => {
      if (isEmpty(userId)) return;

      try {
        // Fetch category data
        const catList = await dispatch(
          sampleTodoListAction.fetchCategoryAction({
            categoryType: 1,
            loggedInUserId: userId,
          }),
        );

        setState((prevState) => ({
          ...prevState,
          categoryOptions: cloneDeep(createOptions(catList, 'name', '_id')),
        }));

        // Fetch seasons data
        await setSeasonsData();
      } catch (error) {
        console.error('Error fetching data:', error);
        // Handle error appropriately (e.g., show error message)
      }
    };

    fetchData();
  }, [dispatch, userId]);

  useEffect(() => {
    const init = async () => {
      if (!filterApplied && !isLoading) {
        setState((prevState) => ({
          ...prevState,
          isLoading: true,
        }));
        filterData(localStorageFilter);
        setFilterOptions(localStorageFilter);
        const years = currentBackYears(localStorageFilter?.year);
        setState((prevState) => ({
          ...prevState,
          filterApplied: true,
          isLoading: false,
          yearPrevOptions: createOptions(years, 'name', '_id'),
        }));
      }
    };

    init();
  }, [localStorageFilter, dispatch, seasonsOptions]);

  const handleFilterSelect = async (val, key) => {
    switch (key) {
      case 'brand':
        const currentSubBrands = Array.isArray(activeSubBrand) ? [...activeSubBrand] : [];
        let newSubBrands = [...currentSubBrands];

        if (Array.isArray(activeBrand) && val.length < activeBrand.length) {
          const removedBrands = activeBrand.filter((id) => !val.includes(id));
          if (removedBrands.length > 0) {
            newSubBrands = currentSubBrands.filter((subBrandId) => {
              if (!subBrandId) return false;
              const subBrand = Array.isArray(multiSubBrandList) ? multiSubBrandList.find((sb) => sb?._id === subBrandId) : null;
              return subBrand && !removedBrands.includes(subBrand?.brandId);
            });
          }
        }

        setState((prevState) => ({
          ...prevState,
          activeBrand: val,
          activeSubBrand: newSubBrands,
        }));

        if (val.length > 0) {
          dispatch(
            systemMasterAction.getMultiSubBrandDetails({
              brandId: val,
              loggedInUserId: userInfo?.userId,
              isActive: 1,
            }),
          );
        }
        break;
      case 'subBrand':
        setState((prevState) => ({
          ...prevState,
          activeSubBrand: val,
        }));
        break;

      case 'productType':
        setState((prevState) => ({
          ...prevState,
          activeProductType: val,
          // reset categories on PT change when cascading is enabled
          ...(catBasedOnPTData && { activeCat1: [], activeCat2: [], activeCat3: [], activeCat4: [] }),
        }));
        break;
      case 'cat1':
        setState((prevState) => ({
          ...prevState,
          activeCat1: val,
          ...(catBasedOnPTData && { activeCat2: [], activeCat3: [], activeCat4: [] }),
        }));
        break;
      case 'cat2':
        setState((prevState) => ({
          ...prevState,
          activeCat2: val,
          ...(catBasedOnPTData && { activeCat3: [], activeCat4: [] }),
        }));
        await dispatch(
          systemMasterAction.getCategory3Details({
            categoryOneId: activeCat1,
            categoryTwoId: val,
            categoryType: 3,
            isActive: true,
            loggedInUserId: userInfo?.userId,
          }),
        );
        break;
      case 'cat3':
        setState((prevState) => ({
          ...prevState,
          activeCat3: val,
          ...(catBasedOnPTData && { activeCat4: [] }),
        }));
        await dispatch(
          systemMasterAction.getCategory4Details({
            categoryOneId: activeCat1,
            categoryTwoId: activeCat2,
            categoryThreeId: val,
            categoryType: 4,
            isActive: true,
            loggedInUserId: userInfo?.userId,
          }),
        );
        break;
      case 'cat4':
        setState((prevState) => ({
          ...prevState,
          activeCat4: val,
        }));
        break;
      case 'supplier':
        setState((prevState) => ({
          ...prevState,
          activeSupplier: val,
        }));
        break;
      case 'season':
        setState((prevState) => ({
          ...prevState,
          activeSeason: val,
        }));
        break;
      case 'month':
        setState((prevState) => ({
          ...prevState,
          activeMonth: val,
        }));
        break;
      case 'year':
        setState((prevState) => ({
          ...prevState,
          activeYear: val,
        }));
        break;
      case 'status':
        setState((prevState) => ({
          ...prevState,
          activeStatus: val,
        }));
        break;
      case 'createBy':
        setState((prevState) => ({
          ...prevState,
          activeCreatedBy: val,
        }));
        break;

      default:
        break;
    }
  };

  const handleFilterDynamicSelect = async (items, colId) => {
    const isColDataExist = dynamicTypes?.filter((e) => e.colId === colId);
    const copyState = cloneDeep(dynamicTypes);
    if (checkArray(isColDataExist)) {
      isColDataExist.forEach((ele) => {
        copyState.splice(
          copyState.findIndex((e) => e.valId === ele.valId),
          1,
        );
      });
    }
    const obj =
      checkArray(items) &&
      items.map((valId) => {
        return { colId, valId };
      });

    setState((prevState) => ({
      ...prevState,
      dynamicTypes: obj ? [...(copyState || []), ...obj] : [...copyState],
    }));
  };

  const currentBackYears = (startYear) => {
    if (startYear) {
      const sYear = startYear;
      const lastYears = sYear - 20;
      const years = [];

      for (let i = startYear - 1; i >= lastYears; i--) {
        years.push({ name: i.toString(), _id: i });
      }
      return years;
    }
    return [];
  };

  const handleSelectChange = async (value, _text, name) => {
    setState((prevState) => ({
      ...prevState,
      isApply: true,
    }));

    if (name === 'level') {
      setState((prevState) => ({
        ...prevState,
        isAll: true,
      }));
    }
    if (name === 'year') {
      const years = currentBackYears(value);
      setState((prevState) => ({
        ...prevState,
        selectedYear: value,

        yearPrevOptions: createOptions(years, 'name', '_id'),
      }));
    }
    if (name === 'season') {
      setState((prevState) => ({
        ...prevState,
        selectedSeason: value,
      }));
    }
    if (name === 'category') {
      setState((prevState) => ({
        ...prevState,
        activeCat1: value,
      }));
    } else {
      setState((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    if (name === 'attributes') {
      setPlanningBottomup((prevState) => ({
        ...prevState,
        selectedDisplayColumn: value,
      }));
    }
  };
  const clearAll = async () => {
    localStorage.removeItem('bottomUpFilter');
    setState((prevState) => ({
      ...prevState,
      selectedYear: '',
      activeCat1: [],
      selectedSeason: '',
      isApply: false,
      level: null,
      activeBrand: [],
      activeSubBrand: [],
      activeProductType: [],
      activeCat2: [],
      activeCat3: [],
      activeCat4: [],
      activeSupplier: [],
      activeSeason: [],
      activeMonth: [],
      activeYear: [],
      activeStatus: [],
      activeCreatedBy: [],
      dynamicTypes: [],
    }));

    setSelectedYear1(null);
    setSelectedSeason1(null);
    setPlanningBottomup((prevState) => ({
      ...prevState,
      planningBottomProducts: null,
    }));

    setPlanningState({ ...planningState, categoryYear: null, level: 0 });
  };
  const checkRequiredField = () => {
    const requirePT = catBasedOnPTData ? checkArray(activeProductType) : true;
    if (selectedYear && selectedSeason && checkArray(activeCat1) && !isEmpty(level) && requirePT) {
      return true;
    }
    toasterMsg(t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.ALL_FIELDS_REQUIRED'), 'danger');
    return false;
  };
  const applyFilter = async () => {
    if (checkRequiredField()) {
      setPlanningState((prev) => ({
        ...prev,
        isLoading: true,
      }));
      setPlanningBottomup((prev) => ({
        ...prev,
        selectedLevel: level,
      }));
      setState((prevState) => ({
        ...prevState,
        filterApplied: true,
        isLoading: true,
      }));
      const responseClear = await dispatch(PlanningBottomAction.clearPlanningBottomData());
      if (responseClear) {
        const paramsObj = {
          year: selectedYear,
          season: selectedSeason,
          seasonText: selectedSeason1,
          categoryOne: activeCat1,
          loading: true,
          level: level?.level,
          brandId: activeBrand,
          subBrandId: activeSubBrand,
          productType: activeProductType,
          catOneId: activeCat1,
          catTwoId: activeCat2,
          catThreeId: activeCat3,
          catFourId: activeCat4,
          supplierId: activeSupplier,
          seasonId: activeSeason,
          month: activeMonth,
          status: activeStatus,
          createdBy: activeCreatedBy,
          dynamicTypes,
        };
        const localStorageObj = {
          ...paramsObj,
          level,
          brandId: activeBrand,
          subBrandId: activeSubBrand,
          productType: activeProductType,
          catOneId: activeCat1,
          catTwoId: activeCat2,
          catThreeId: activeCat3,
          catFourId: activeCat4,
          supplierId: activeSupplier,
          seasonId: activeSeason,
          month: activeMonth,
          year: selectedYear,
          status: activeStatus,
          createdBy: activeCreatedBy,
          dynamicTypes,
          isAllSelected: attributesOptions?.length === selectedDisplayColumn?.length,
          selectedDisplayColumn,
        };
        localStorage.setItem('bottomUpFilter', JSON.stringify(localStorageObj));
        filterData(paramsObj);
        const response = await dispatch(PlanningBottomAction.getBottomData(paramsObj));
        if (response) {
          setPlanningState((prev) => ({
            ...prev,
            isLoading: false,
            level: level?.level,
          }));
        }
        setState((prevState) => ({
          ...prevState,
          isLoading: false,
        }));

        setPlanningBottomup((prev) => ({
          ...prev,
          changed: !prev.changed,
          selectedLevel: level,
          currLevel: level?.level,
        }));
      }
    }
  };
  const setFilterOptions = (filteredData) => {
    let count = 0;
    for (const keys in filteredData) {
      if (filteredData[keys]) {
        count += 1;
      }
    }
    if (count > 0) {
      setState((prevState) => ({
        ...prevState,
        isApply: true,
      }));
    }
    const getYearObj = yearOptions.find((yearEle) => yearEle._id === filteredData?.year);
    getYearObj &&
      setState((prevState) => ({
        ...prevState,
        selectedYear: getYearObj._id,
      }));

    setState((prevState) => ({
      ...prevState,
      selectedSeason: filteredData?.season,
    }));

    setSelectedYear1(getYearObj);
    setSelectedSeason1(filteredData?.seasonText ? filteredData.seasonText : null);
    setState((prevState) => ({
      ...prevState,
      activeCat1: filteredData?.categoryOne,
      level: filteredData?.level,
      activeCat2: filteredData?.catTwoId,
      activeCat3: filteredData?.catThreeId,
      activeCat4: filteredData?.catFourId,
      activeSupplier: filteredData?.supplierId,
      activeSeason: filteredData?.seasonId,
      activeMonth: filteredData?.month,
      activeYear: filteredData?.year,
      activeStatus: filteredData?.status,
      activeCreatedBy: filteredData?.createdBy,
      activeBrand: filteredData?.brandId,
      activeProductType: filteredData?.productType,
      dynamicTypes: filteredData?.dynamicTypes,
    }));
  };

  // Cascading: derive filtered options when company flag is ON
  const category1Filtered = useMemo(() => {
    if (!catBasedOnPTData) return category1Options;
    const pts = activeProductType || [];
    if (!checkArray(pts)) return category1Options;
    const base = state?.category1Raw || [];
    const filtered = base.filter((item) => {
      const ptArr = item?.productType || [];
      const usedPtArr = item?.isUsedProductType || [];
      return ptArr?.some?.((id) => pts.includes(id)) || usedPtArr?.some?.((id) => pts.includes(id));
    });
    if (!filtered?.length) return category1Options;
    return createOptions(filtered, 'name', '_id');
  }, [catBasedOnPTData, activeProductType, category1Options, state?.category1Raw]);

  const category2Filtered = useMemo(() => {
    if (!catBasedOnPTData) return category2Options;
    const cat1 = activeCat1 || [];
    if (!checkArray(cat1)) return category2Options;
    const base = state?.category2Raw || [];
    const filtered = base.filter((item) => {
      const usedCat1 = item?.isUsedCat1 || [];
      return usedCat1?.some?.((id) => cat1.includes(id));
    });
    if (!filtered?.length) return category2Options;
    return createOptions(filtered, 'name', '_id');
  }, [catBasedOnPTData, activeCat1, category2Options, state?.category2Raw]);

  const category3Filtered = useMemo(() => {
    if (!catBasedOnPTData) return category3Options;
    const cat1 = activeCat1 || [];
    const cat2 = activeCat2 || [];
    if (!checkArray(cat1) || !checkArray(cat2)) return category3Options;
    const base = state?.category3Raw || [];
    const filtered = base.filter((item) => cat1.includes(item?.categoryOneId) && cat2.includes(item?.categoryTwoId));
    if (!filtered?.length) return category3Options;
    return createOptions(filtered, 'name', '_id');
  }, [catBasedOnPTData, activeCat1, activeCat2, category3Options, state?.category3Raw]);

  const category4Filtered = useMemo(() => {
    if (!catBasedOnPTData) return category4Options;
    const cat1 = activeCat1 || [];
    const cat2 = activeCat2 || [];
    const cat3 = activeCat3 || [];
    if (!checkArray(cat1) || !checkArray(cat2) || !checkArray(cat3)) return category4Options;
    const base = state?.category4Raw || [];
    const filtered = base.filter((item) => cat1.includes(item?.categoryOneId) && cat2.includes(item?.categoryTwoId) && cat3.includes(item?.categoryThreeId));
    if (!filtered?.length) return category4Options;
    return createOptions(filtered, 'name', '_id');
  }, [catBasedOnPTData, activeCat1, activeCat2, activeCat3, category4Options, state?.category4Raw]);

  return (
    <>
      <div className="custom-react-select w-200px ml-2">
        <MultiSelect
          name="attributes"
          options={attributesOptions}
          className="custom-multiselect border-bottom-none"
          value={attributesOptions?.filter((val) => !isEmpty(selectedDisplayColumn) && selectedDisplayColumn?.includes(val?.value))}
          labelledBy={t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.ATTRIBUTES')}
          onChange={(selected) => {
            handleSelectChange(
              selected.map((val) => val?.value),
              selected.map((val) => val?.label),
              'attributes',
            );
          }}
        />
      </div>
      <button
        type="button"
        aria-label="sort"
        title={t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.SORT')}
        className={isApply ? 'filter-btn filter-button_delete active' : 'filter-btn filter-button_delete'}
      >
        <OverlayTrigger
          placement="bottom"
          trigger="click"
          rootClose
          overlay={
            <Popover className="custom-popover select-min-height popover-filter">
              <Popover.Content>
                <Row className="form-row">
                  <Col xs={6} md={2}>
                    <FormGroup className="mb-2">
                      <label className="select-label asterisk-req">
                        {t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.YEAR')}
                        <span>*</span>
                      </label>
                      <div className="custom-react-select ">
                        <Select
                          components={{ Option: CurrentYearOption }}
                          name="year"
                          styles={customStyles}
                          isClearable
                          options={yearOptions || []}
                          getOptionLabel={(option) => `${option.label}`}
                          getOptionValue={(option) => `${option.value}`}
                          value={selectedYear1 || null}
                          onChange={(val) => {
                            setSelectedYear1(val);
                            handleSelectChange(val ? val._id : null, val ? val.name : null, 'year');
                          }}
                          placeholder={t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.SELECT_YEAR')}
                        />
                      </div>
                    </FormGroup>
                  </Col>

                  <Col xs={6} md={2}>
                    <FormGroup className="mb-2">
                      <label className="select-label asterisk-req">
                        {t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.SEASON')}
                        <span>*</span>
                      </label>
                      <div className="custom-react-select ">
                        <Select
                          name="season"
                          styles={customStyles}
                          isClearable
                          options={seasonsOptions || []}
                          getOptionLabel={(option) => `${option.label}`}
                          getOptionValue={(option) => `${option.value}`}
                          value={selectedSeason1 || null}
                          onChange={(val) => {
                            setSelectedSeason1(val);
                            handleSelectChange(val ? val._id : null, val ? val.name : null, 'season');
                          }}
                          placeholder={t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.SELECT_SEASON')}
                        />
                      </div>
                    </FormGroup>
                  </Col>
                  <Col xs={6} md={2}>
                    <FormGroup className="mb-2">
                      <label className="select-label asterisk-req">
                        {t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.LEVEL')}
                        <span>*</span>
                      </label>
                      <div className="custom-react-select ">
                        <Select
                          name="year"
                          styles={customStyles}
                          isClearable
                          options={filterOptions || []}
                          getOptionLabel={(option) => `${option.name}`}
                          getOptionValue={(option) => `${option._id}`}
                          value={level || null}
                          onChange={(val) => {
                            handleSelectChange(val, 'level', 'level');
                          }}
                          placeholder={t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.SELECT_LEVEL')}
                        />
                      </div>
                    </FormGroup>
                  </Col>

                  <Col xs={6} md={2}>
                    <FormGroup>
                      <label className="select-label  asterisk-req">{t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.BRAND')}</label>
                      <MultiSelect
                        name="group"
                        options={brandOptions}
                        className="custom-multiselect w-100"
                        value={brandOptions?.filter((val) => checkArray(brandOptions) && activeBrand?.includes(val._id))}
                        labelledBy={t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.SELECT_BRAND')}
                        overrideStrings={{
                          selectSomeItems: t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.SELECT_BRAND'),
                        }}
                        onChange={(selected) =>
                          handleFilterSelect(
                            selected.map((val) => val.value),
                            'brand',
                          )
                        }
                      />
                    </FormGroup>
                  </Col>
                  {subBrandAccess && (
                    <Col xs={6} md={2}>
                      <FormGroup>
                        <label className="select-label  asterisk-req">{t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.SUB_BRAND')}</label>
                        <MultiSelect
                          name="group"
                          options={subBrandOptions}
                          className="custom-multiselect w-100"
                          value={subBrandOptions?.filter((val) => checkArray(subBrandOptions) && activeSubBrand?.includes(val._id))}
                          labelledBy={t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.SELECT_SUB_BRAND')}
                          overrideStrings={{
                            selectSomeItems: t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.SELECT_SUB_BRAND'),
                          }}
                          onChange={(selected) =>
                            handleFilterSelect(
                              selected.map((val) => val.value),
                              'subBrand',
                            )
                          }
                        />
                      </FormGroup>
                    </Col>
                  )}
                  <Col xs={6} md={2}>
                    <FormGroup>
                      <label className="select-label asterisk-req">
                        {t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.PRODUCT_TYPE')}
                        {catBasedOnPTData && <span>*</span>}
                      </label>
                      <MultiSelect
                        name="group"
                        options={productTypeOptions}
                        className="custom-multiselect w-100"
                        value={productTypeOptions?.filter((val) => checkArray(productTypeOptions) && activeProductType?.includes(val.value))}
                        labelledBy={t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.SELECT_PRODUCT_TYPE')}
                        overrideStrings={{
                          selectSomeItems: t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.SELECT_PRODUCT_TYPE'),
                        }}
                        onChange={(selected) =>
                          handleFilterSelect(
                            selected.map((val) => val.value),
                            'productType',
                          )
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col xs={6} md={2}>
                    <FormGroup>
                      <label className="select-label  asterisk-req">
                        {t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.CATEGORY_1')}
                        <span>*</span>
                      </label>
                      <MultiSelect
                        name="group"
                        options={catBasedOnPTData ? category1Filtered : category1Options}
                        className="custom-multiselect w-100"
                        value={(catBasedOnPTData ? category1Filtered : category1Options)?.filter(
                          (val) => checkArray(catBasedOnPTData ? category1Filtered : category1Options) && activeCat1?.includes(val.value),
                        )}
                        labelledBy={t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.SELECT_CATEGORY_1')}
                        overrideStrings={{
                          selectSomeItems: t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.SELECT_CATEGORY_1'),
                        }}
                        onChange={(selected) =>
                          handleFilterSelect(
                            selected.map((val) => val.value),
                            'cat1',
                          )
                        }
                      />
                    </FormGroup>
                  </Col>

                  <Col xs={6} md={2}>
                    <FormGroup>
                      <label className="select-label  asterisk-req">{t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.CATEGORY_2')}</label>
                      <MultiSelect
                        name="group"
                        options={catBasedOnPTData ? category2Filtered : category2Options}
                        className="custom-multiselect w-100"
                        value={(catBasedOnPTData ? category2Filtered : category2Options)?.filter(
                          (val) => checkArray(catBasedOnPTData ? category2Filtered : category2Options) && activeCat2?.includes(val.value),
                        )}
                        labelledBy={t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.SELECT_CATEGORY2')}
                        overrideStrings={{
                          selectSomeItems: t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.SELECT_CATEGORY2'),
                        }}
                        onChange={(selected) =>
                          handleFilterSelect(
                            selected.map((val) => val.value),
                            'cat2',
                          )
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col xs={6} md={2}>
                    <FormGroup>
                      <label className="select-label  asterisk-req">{t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.CATEGORY_3')}</label>
                      <MultiSelect
                        name="group"
                        options={catBasedOnPTData ? category3Filtered : category3Options}
                        className="custom-multiselect w-100"
                        value={(catBasedOnPTData ? category3Filtered : category3Options)?.filter(
                          (val) => checkArray(catBasedOnPTData ? category3Filtered : category3Options) && activeCat3?.includes(val.value),
                        )}
                        labelledBy={t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.SELECT_CATEGORY_3')}
                        overrideStrings={{
                          selectSomeItems: t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.SELECT_CATEGORY_3'),
                        }}
                        onChange={(selected) =>
                          handleFilterSelect(
                            selected.map((val) => val.value),
                            'cat3',
                          )
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col xs={6} md={2}>
                    <FormGroup>
                      <label className="select-label  asterisk-req">{t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.CATEGORY_4')}</label>
                      <MultiSelect
                        name="group"
                        options={catBasedOnPTData ? category4Filtered : category4Options}
                        className="custom-multiselect w-100"
                        value={(catBasedOnPTData ? category4Filtered : category4Options)?.filter(
                          (val) => checkArray(catBasedOnPTData ? category4Filtered : category4Options) && activeCat4?.includes(val.value),
                        )}
                        labelledBy={t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.SELECT_CATEGORY_4')}
                        overrideStrings={{
                          selectSomeItems: t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.SELECT_CATEGORY_4'),
                        }}
                        onChange={(selected) =>
                          handleFilterSelect(
                            selected.map((val) => val.value),
                            'cat4',
                          )
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col xs={6} md={2}>
                    <FormGroup>
                      <label className="select-label  asterisk-req">{t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.SUPPLIER')}</label>
                      <MultiSelect
                        name="group"
                        options={supplierOptions}
                        className="custom-multiselect w-100"
                        value={supplierOptions?.filter((val) => checkArray(supplierOptions) && activeSupplier?.includes(val.value))}
                        labelledBy={t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.SELECT_SUPPLIER')}
                        overrideStrings={{
                          selectSomeItems: t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.SELECT_SUPPLIER'),
                        }}
                        onChange={(selected) =>
                          handleFilterSelect(
                            selected.map((val) => val.value),
                            'supplier',
                          )
                        }
                      />
                    </FormGroup>
                  </Col>

                  <Col xs={6} md={2}>
                    <FormGroup>
                      <label className="select-label  asterisk-req" htmlFor="monthTopSelect">
                        {t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.MONTH')}
                      </label>
                      <MultiSelect
                        name="group"
                        options={monthOptions}
                        className="custom-multiselect w-100"
                        value={monthOptions?.filter((val) => checkArray(monthOptions) && activeMonth?.includes(val.value))}
                        labelledBy={t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.SELECT_MONTH')}
                        overrideStrings={{
                          selectSomeItems: t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.SELECT_MONTH'),
                        }}
                        onChange={(selected) =>
                          handleFilterSelect(
                            selected.map((val) => val.value),
                            'month',
                          )
                        }
                      />
                    </FormGroup>
                  </Col>

                  {!isEmpty(dynamicFields) &&
                    dynamicFields.map((ele, i) => {
                      let selectOpt = null;

                      if (ele.type === 'dropdown') {
                        selectOpt = createOptions(ele.values, 'keyName', '_id');
                      }

                      if (ele.type === 'dropdown' && ele.isActive) {
                        return (
                          <Col xs={6} md={2} key={i}>
                            <FormGroup className="mb-0">
                              <p className="select-label mb-0">{ele?.keyName}</p>
                              <div className="custom-react-select ">
                                <MultiSelect
                                  name="group"
                                  options={selectOpt}
                                  className="custom-multiselect w-100"
                                  value={selectOpt?.filter((val) => checkArray(selectOpt) && dynamicTypes?.some((e) => e.valId === val._id))}
                                  labelledBy={`Select ${ele.keyName}`}
                                  overrideStrings={{
                                    selectSomeItems: `Select ${ele.keyName}`,
                                  }}
                                  onChange={(selected) =>
                                    handleFilterDynamicSelect(
                                      selected.map((val) => val._id),
                                      ele?._id,
                                    )
                                  }
                                />
                              </div>
                            </FormGroup>
                          </Col>
                        );
                      }
                    })}
                  <Col xs={6} md={2}>
                    <FormGroup>
                      <p className="select-label mb-0">{t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.STATUS')}</p>
                      <MultiSelect
                        name="group"
                        options={productStatusOptions}
                        className="custom-multiselect w-100"
                        value={productStatusOptions?.filter((val) => checkArray(productStatusOptions) && activeStatus?.includes(val.value))}
                        labelledBy={t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.SELECT_STATUS')}
                        overrideStrings={{
                          selectSomeItems: t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.SELECT_STATUS'),
                        }}
                        onChange={(selected) =>
                          handleFilterSelect(
                            selected.map((val) => val.value),
                            'status',
                          )
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col xs={6} md={2}>
                    <FormGroup>
                      <p className="select-label mb-0">{t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.CREATED_BY')}</p>
                      <MultiSelect
                        name="group"
                        options={createdByOption}
                        className="custom-multiselect w-100"
                        value={createdByOption?.filter((val) => checkArray(createdByOption) && activeCreatedBy?.includes(val.value))}
                        labelledBy={t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.SELECT_CREATED_BY')}
                        overrideStrings={{
                          selectSomeItems: t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.SELECT_CREATED_BY'),
                        }}
                        onChange={(selected) =>
                          handleFilterSelect(
                            selected.map((val) => val.value),
                            'createBy',
                          )
                        }
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="d-flex justify-content-end">
                      <button type="button" disabled={isLoading} className="btn btn-default mr-2" onClick={() => applyFilter()}>
                        {t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.APPLY')}
                      </button>
                      <button type="button" className="btn btn-default" onClick={() => clearAll()}>
                        {t('PLANING_BOTTOM_UP.FILTER_TOP_BUTTOMS.CLEAR')}
                      </button>
                    </div>
                  </Col>
                </Row>
              </Popover.Content>
            </Popover>
          }
        >
          <i className="icon-filter" />
        </OverlayTrigger>
      </button>
    </>
  );
}

export default FilterBottomTop;
